import { ErrorPage } from '@/components/errors';

/**
 * 404 Not Found Page
 *
 * Displayed when a user navigates to a route that does not exist.
 * Provides navigation options to help users find their way.
 */
export function NotFoundPage() {
  return (
    <ErrorPage
      code={404}
      title="Page not found"
      message="Sorry, we could not find the page you are looking for. It may have been moved or deleted."
      showRetry={false}
      showReload={false}
      showHomeLink
      showDashboardLink
    />
  );
}

export default NotFoundPage;
